export enum PhotobookGroupEnum {
  Photobook = 'photobook',
  PhotobookPic = 'photobook-pic',
  PhotobookPfe = 'photobook-pfe',
  PhotobookSbe = 'photobook-sbe'
}
